import React, { memo } from 'react';
import { path } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { useCategoriesVariables } from '../../../../hooks/useCategoriesVariables';
import { RoundIconsWrapper } from '../RoundIconsWrapper';
import { GameControlsWrapper } from '../GameControlsWrapper';
import { GameDetailsWrapper } from '../GameDetailsWrapper';
import { GameImageWrapper } from '../GameImageWrapper';

import { PortraitLandscapeGameInfoProps } from '../../types';
import style from './LandscapeGameInfoMobile.scss';
import { clsx } from 'js/utils/classNames.util';

export const LandscapeGameInfoMobile = ({
    image,
    name,
    funSupport,
    showFavorite,
    description,
    code,
    hideButtons,
    gameLaunchType,
    isNew,
    hot,
    popular,
    exclusive,
    descriptionGameProvider,
    longImg,
    t,
    gameDescription,
    handleShowGameDetails,
    showGameDetails,
    className = ''
}: PortraitLandscapeGameInfoProps) => {
    const {
        isBecauseYouPlayed,
        categoryName,
        isRecommended,
        isCategoryName,
        mostPlayedGame
    } = useCategoriesVariables();

    const username = useUserSelector(path(['userDetails', 'firstName']));

    return (
        <div className={
            clsx([
                className,
                style.container,
                showGameDetails ? style.containerShowDetails : ''
            ])
        }>
            <div className={`${style.left} ${showGameDetails ? style.leftShowDetails : ''}`}>
                <GameImageWrapper
                    code={code}
                    longImg={longImg}
                    image={image}
                    showGameDetails={showGameDetails}
                    t={t}
                    categoryName={categoryName}
                    isRecommended={isRecommended}
                    mostPlayedGame={mostPlayedGame}
                    username={username as string}
                    isBecauseYouPlayed={isBecauseYouPlayed}
                    isCategoryName={isCategoryName}
                    name={name}
                />
            </div>
            <div className={`${style.right} ${showGameDetails ? `${style.rightShowDetails}` : ''}`}>
                <GameDetailsWrapper
                    t={t}
                    categoryName={categoryName}
                    isRecommended={isRecommended}
                    mostPlayedGame={mostPlayedGame}
                    username={username as string}
                    name={name}
                    isBecauseYouPlayed={isBecauseYouPlayed}
                    isCategoryName={isCategoryName}
                    isNew={isNew}
                    isPopular={popular}
                    isHot={hot}
                    isExclusive={exclusive}
                    shortDescription={description}
                    fullDescription={gameDescription}
                    showGameDetails={showGameDetails}
                    handleShowGameDetails={handleShowGameDetails}
                    descriptionGameProvider={descriptionGameProvider}
                    code={code}
                />
                {!showGameDetails && (
                    <>
                        <RoundIconsWrapper
                            code={code}
                            name={name}
                            t={t}
                            showFavorite={showFavorite}
                            className={style.roundIconsMargin}
                            handleShowGameDetails={handleShowGameDetails}
                        />
                    </>
                )}
                <GameControlsWrapper
                    hideButtons={hideButtons}
                    funSupport={funSupport}
                    code={code}
                    name={name}
                    gameLaunchType={gameLaunchType}
                    className={`${style.buttonWrapper}${showGameDetails ? ` ${style.buttonWrapperShowDetails}` : ''}`}
                />
            </div>
        </div>
    );
};

export default memo(LandscapeGameInfoMobile);
